'use strict';

window.Vue = require('vue').default;

Vue.prototype.trans = function (str) {
    return str;
};

require('./bootstrap');
require('./mixins/OrderFormMixin');

/// init
var vApp = new Vue({
    el: '#app',
    methods: {}
});


/// legacy
require('./custom-scripts')
